<form [formGroup]="formGroup">
  <glxy-form-field [required]="true">
    <glxy-label>{{ 'SMS_REGULATION.COMMON.ADDRESS.STREET_ADDRESS_PRIMARY' | translate }}</glxy-label>
    <input matInput formControlName="streetAddress1" />
  </glxy-form-field>
  <glxy-form-field>
    <glxy-label>{{ 'SMS_REGULATION.COMMON.ADDRESS.STREET_ADDRESS_SECONDARY' | translate }}</glxy-label>
    <input matInput formControlName="streetAddress2" />
  </glxy-form-field>
  <glxy-form-row>
    <glxy-form-field [required]="true">
      <glxy-label>{{ 'SMS_REGULATION.COMMON.ADDRESS.CITY' | translate }}</glxy-label>
      <input matInput formControlName="city" />
    </glxy-form-field>
    <glxy-form-field [required]="true">
      <glxy-label>{{ 'SMS_REGULATION.COMMON.ADDRESS.STATE' | translate }}</glxy-label>
      <input matInput formControlName="state" />
    </glxy-form-field>
  </glxy-form-row>
  <glxy-form-field [required]="true">
    <glxy-label>{{ 'SMS_REGULATION.COMMON.ADDRESS.POSTAL_CODE' | translate }}</glxy-label>
    <input matInput formControlName="postalCode" />
  </glxy-form-field>
</form>
